import { Component, inject, signal } from '@angular/core';
import { HamburgerStateService } from '../hamburger-state.service';
import { Router } from '@angular/router';
import * as download from 'downloadjs';
import { StorageService } from '../../services/storage.service';
import { UserService } from '../../services/userService/user.service';

@Component({
  selector: 'app-hamburger-menu',
  templateUrl: './hamburger-menu.component.html',
  styleUrl: './hamburger-menu.component.scss',
  standalone: false,
})
export class HamburgerMenuComponent {
  public service = inject(HamburgerStateService);
  private router = inject(Router);
  private userService = inject(UserService);
  private storageService = inject(StorageService);
  buttons= this.service.buttons;
  accordion = signal<boolean>(false);
  menuData: any;
  menuStack: { menu: any[], title: string }[] = [];
  currentMenu: any[] = [];
  currentTitle = 'Menu';

  

  ngOnInit(): void {
    this.menuData = this.service.menuData;
    this.currentMenu = this.menuData.mainMenu;
  }

  handleItemClick(item: any): void {
    if (item.hasSubMenu) {
      this.menuStack.push({ menu: this.currentMenu, title: this.currentTitle });
      this.currentMenu = item.subMenu;
      this.currentTitle = item.name;
    } else if (item.hasNextedMenu) {
      this.menuStack.push({ menu: this.currentMenu, title: this.currentTitle });
      this.currentMenu = item.nextedMenu;
      this.currentTitle = item.name;
    } else if (item.hasNestedSubMenu) {
      this.menuStack.push({ menu: this.currentMenu, title: this.currentTitle });
      this.currentMenu = item.nestedSubMenu;
      this.currentTitle = item.name;
    } else {
      this.router.navigateByUrl(item.url as string);
    }
  }
  
  

  goBack(): void {
    const prev = this.menuStack.pop();
    if (prev) {
      this.currentMenu = prev.menu;
      this.currentTitle = prev.title;
    }
  }

  toggleAccordion(item: any): void {
    item.expanded = !item.expanded;
  }

    downloadpdf(url: string): void {
      download(url);
    }

    getFileExtension(url: string): string {
      if (!url) return '';

      const cleanUrl = url.split(/[?#]/)[0];
      const fileName = cleanUrl.split('/').pop() || '';
      const extension = fileName.includes('.') ? fileName.split('.').pop() : '';

      return extension ? extension.toUpperCase() : '';
    }

    logOut() {
      this.userService.logOut().subscribe(() => {
        this.storageService.removeData('access_token');
        this.router.navigate(['/']);
        this.userService.onUserLoginStateChange();
        window.history.forward();
      });
    }
}
